import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ShortContentComponent } from '@components/common/short-content/short-content.component';
import { IdeaEvidence } from '@models/Sessions/Idea/evidence';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { FilterByPipe } from '@pipes/array/filter-by.pipe';
import { ShortDomainPipe } from '@pipes/short-domain.pipe';

@Component({
  selector: 'app-refs-list',
  standalone: true,
  imports: [
    CommonModule,
    NgbPopoverModule,
    ShortDomainPipe,
    ShortContentComponent,
    FilterByPipe,
  ],
  templateUrl: './refs-list.component.html',
  styleUrl: './refs-list.component.scss',
})
export class RefsListComponent {
  @Input() refs: IdeaEvidence[] = [];
}
